{
  "version": 1,
  "asset_id": "8e0305b1-be42-44dc-a0c4-7cdbce645cc7",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/8e0305b1-be42-44dc-a0c4-7cdbce645cc7/scar-tissue-crura-esophagus-es-1200.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/8e0305b1-be42-44dc-a0c4-7cdbce645cc7/scar-tissue-crura-esophagus-es-1200.webp",
  "original_filename": "scar-tissue-crura-esophagus-es-1200.webp",
  "size": 141806,
  "content_type": "image/webp",
  "created_at": "2026-10-04T15:56:16Z"
}
